import { useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useStockItemDetailsQuery } from "./useStockItemsQueries";

export const useStockItemDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { search } = useLocation();
  const { data: stockItemDetails, isLoading } = useStockItemDetailsQuery(
    Number(id),
  );

  const handleChange = (event, newValue) => {
    navigate(`/stock-items/details/${id}${newValue}`);
  };

  useLayoutEffect(() => {
    if (!search) {
      navigate(`?basic-details`);
    }
  }, [search]);

  return { handleChange, search, stockItemDetails, isLoading };
};
